export default [
  {
    path: "/ai-invoices",
    name: "ai-invoices",
    component: () => import("@/modules/ai-invoices/AiInvoices.vue"),
    children: [
      {
        path: "list",
        name: "list-ai-invoices",
        component: () =>
          import("@/modules/ai-invoices/pages/AiInvoicesList.vue"),
        meta: { permissions: ["ai-invoices-show"] }
      },
      {
        path: "type/:typeSlug",
        name: "list-ai-invoices-by-type",
        component: () =>
          import("@/modules/ai-invoices/pages/AiInvoicesListByType.vue"),
        props: route => ({ invoiceTypeSlug: route.params.typeSlug }),
        meta: { permissions: ["ai-invoices-show"] }
      },
      {
        path: "add",
        name: "add-ai-invoices",
        component: () => import("@/modules/ai-invoices/pages/AiInvoiceAdd.vue"),
        meta: { permissions: ["ai-invoices-create"] }
      }
    ]
  }
];
